import http from "@/http";

export default {
  index(context) {
    return new Promise((resolve, reject) => {
      context.state.docs = [];
      context.state.totalDocs = 0;
      context.state.loading = true;
      http
        .post(`/request/service/index`, {
          search: context.state.search,
          limit: context.state.limit,
          page: context.state.page,
          serviceType: context.state.serviceType,
          status: context.state.status,
          visitType: context.state.visitType,
          sort: context.state.sort
        })
        .then(response => {
          context.state.loading = false;
          context.state.docs = response.data.docs;
          context.state.totalDocs = response.data.totalDocs;
          context.state.totalPages = response.data.totalPages;
          resolve(response);
        })
        .catch(error => {
          context.state.loading = false;
          reject(error);
        });
    });
  },
  show(context, id) {
    return new Promise((resolve, reject) => {
      context.state.loading = true;
      http
        .get(`/request/service/show/${id}`)
        .then(response => {
          context.state.loading = false;
          resolve(response);
        })
        .catch(error => {
          context.state.loading = false;
          reject(error);
        });
    });
  },
  store(context, service) {
    return new Promise((resolve, reject) => {
      context.state.loading = true;
      http
        .post(`/request/service/store/${service.engineer._id}`, service)
        .then(response => {
          console.log("dispatch store successfull");
          resolve(response);
        })
        .catch(error => {
          console.log("dispatch store failed");
          reject(error);
        });
    });
  },
  update(context, service) {
    return new Promise((resolve, reject) => {
      context.state.loading = true;
      http
        .post(`/request/service/update/${service._id}`, service)
        .then(response => {
          context.state.loading = false;
          resolve(response);
        })
        .catch(error => {
          context.state.loading = false;
          reject(error);
        });
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      http
        .get(`/request/service/delete/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
